var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Children, cloneElement, isValidElement } from 'react';
import { footerStyle } from './styles';
import { useDialog } from './dialog-context';
import Button from './button';
function Footer(_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    var _b = useDialog(), alignCenter = _b.alignCenter, autoFocusRef = _b.autoFocusRef;
    // Add a reference to the button with autoFocus (if present), so that it can be focused on open
    function renderChildren() {
        return Children.map(children, function (child) {
            if (isValidElement(child)) {
                return child.type === Button && child.props.autoFocus
                    ? cloneElement(child, __assign(__assign({}, child.props), { ref: autoFocusRef }))
                    : child;
            }
            return child;
        });
    }
    return (_jsx("footer", __assign({}, restProps, { css: footerStyle({ alignCenter: alignCenter }) }, { children: renderChildren() })));
}
export default Footer;
